export default __webpack_public_path__ + "static/media/02_tag_free-parking.ba5364be.svg";